var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductShowcaseFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,528a80.09,80.09,0,0,0-80,80v80H128v-147L368,440l74.46,88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672,
    y: 528,
    width: 64,
    height: 320,
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800,240a127.68,127.68,0,0,0-96,43.35A128,128,0,0,0,480,368c0,1.1,0,2.21,0,3.3C481.81,493.49,581.39,592,704,592s222.19-98.51,224-220.7c0-1.09,0-2.2,0-3.3A128,128,0,0,0,800,240Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,371.3c0-1.09,0-2.2,0-3.3a128,128,0,0,1,224-84.65A128.21,128.21,0,0,1,832,244V148a36,36,0,0,0-36-36H100a36,36,0,0,0-36,36V716a36,36,0,0,0,36,36H354.22A259.45,259.45,0,0,1,352,718V688H128V541L368,440l74.46,88H542c1.78,0,3.55,0,5.32.07A223.34,223.34,0,0,1,480,371.3Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,592H432a16,16,0,0,0-16,16V718c0,107.14,86.86,194,194,194H720a16,16,0,0,0,16-16V786c0-107.14-86.86-194-194-194Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944,624H866a193.07,193.07,0,0,0-102.66,29.37A257.21,257.21,0,0,1,800,786V896a79.92,79.92,0,0,1-1.11,13.21C890.37,893.59,960,813.93,960,718V640A16,16,0,0,0,944,624Z",
    style: {
      fill: "#006eff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseFilled);
export default __webpack_public_path__ + "static/media/productShowcaseFilled.1adccf8bd1c02582a0e47488e5029b63.svg";
export { ForwardRef as ReactComponent };